import { ON_SUBMIT_INVALID_METADATA_KEY } from './metadata-keys';
import { addToMetadata } from '@digitaix/helpers';

export function OnSubmitInvalid(order: number = -1) {
  return function(
    target: any,
    propertyKey: string
  ) {
    addToMetadata(
      ON_SUBMIT_INVALID_METADATA_KEY,
      {
        order,
        propertyKey
      },
      target
    );
  };
}
